import Cookies from "js-cookie";
import { ReactNode, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAtom } from "jotai";
import { isPasscodeAuthenticatedAtom } from "../../atoms";
import { environment } from "../../constants/environment";

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const [isPasscodeAuthenticated, setIsPasscodeAuthenticated] = useAtom(
    isPasscodeAuthenticatedAtom
  );
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const checkAuth = () => {
      const cookieAuth = Cookies.get("demo_authenticated");
      const isAuthenticated = cookieAuth === "true";

      setIsPasscodeAuthenticated(isAuthenticated);
      setIsLoading(false);
    };

    // Small timeout to ensure document is fully loaded
    const timeoutId = setTimeout(checkAuth, 100);

    return () => clearTimeout(timeoutId);
  }, [setIsPasscodeAuthenticated]);

  // Show loading state while checking authentication
  if (isLoading) {
    return null; // or a loading spinner
  }

  if (environment.MODE === "production" && !isPasscodeAuthenticated) {
    // Redirect to passcode page, but save the location they were trying to access
    return <Navigate to="/passcode" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
